import { configureStore } from '@reduxjs/toolkit';
import combineReducers from './combine-reducers';

const store = configureStore({
  reducer: combineReducers,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
